import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    ...zhLocale,
    customer: {
        service_log: "服务记录",
        service_log_add: "添加服务记录",
        service_log_edit: "编辑服务记录",
        user_name: '用户名称',
    },
    tab: {
        sort: '排序',
        save: '保存',
        cancel: '取消',
        //反垃圾配置  SMTP参数
        smtp: 'SMTP基本参数',
        spams: '安全基本参数',
        virus: '反病毒基本参数',
        lagc: '日志清理设置',
        alert: '警报设置',
        real: '实时黑名单',
        remote: '远程syslog配置',
        remote1: '离线测试配置',
        // SMTP参数 页面
        smtp1: '客户端IP最大并发连接',
        smtp2: '单位时间单IP最大允许连接数',
        smtp3: '单位时间单IP邮件数限制',
        smtp4: '单位时间单IP最大允许收件人数',
        smtp5: 'SMTP允许最大邮件大小',
        smtp6: '队列最长生命周期',
        smtp7: 'SMTP错误指令次数限制',
        smtp8: 'SMTP单个会话最大字节数',
        smtp8_title: '单个会话字节数不低于10M',
        smtp9: 'SMTP单个会话最大消息数',
        smtp10: 'SMTP问候延迟(<=30s)',
        smtp11: '单封邮件最大收件人数',
        smtp12: '本地网络',
        smtp13: '朋友网络',
        smtp14: '未知网络',
        // 反垃圾基本参数

        spams1: '拦截动作',
        spams2: '是否启动自动白名单',
        spams3: '拦截垃圾是否隔离',
        spams4: '是否启用内容白名单',
        spams5: '是否启用弱密码检查',
        spams6: '是否启用SMTP认证IP控制',
        spams7: '关闭统计本地指纹',
        spams8: '主题审计周期',
        spams9: '主题审计次数',
        spams10: '同一IP最大不同url数',
        spams11: 'url黑名单检查最大链接数',
        spams12: '通知邮件标题',
        spams13: '增加标记的信头key',
        spams14: '增加标记的信头value',
        spams15: '最大SMTP连接数',
        spams16: 'SMTP最大允许空闲',
        spams17: 'ip段最大允许并发',
        spams18: 'SMTP的MTA基础频率周期(秒)',
        spams19: '计算客户端连接速率和其他速率所用的时间单位。',
        spams20: 'MTA自带反向解析',
        spams21: 'defer队列投递间隔最低时间(秒)',
        spams22: 'defer队列投递间隔最大时间(秒)',
        spams23: 'defer队列投递扫描周期(秒)',
        spams24: 'defer队列投递扫描周期(秒)',
        spams25: '退信周期',
        spams26: '最大队列生成周期(天)',
        spams27: '退信账号名字',
        spams28: '策略防护等级',
        spams29: 'DMARC过滤动作',
        spams30: '匿名邮件拦截',
        spams31: '是否开启主题审计',

        spams2001: '系统正常来往邮件自动加入白名单',
        spams3001: '启用后，内容阶段被拒绝的垃圾邮件，均会在隔离区保留一份单副本',
        spams4001: '启用内容白名单,可以设置主题正文包含的关键字白名单，匹配后不再过滤',
        spams5001: '启用后，用户认证发信的密码将会行弱密码检测',
        spams6001: '启用后，未授权的IP地址，将无法通过网关SMTP认证发送邮件',
        spams7001: '关闭后，本地邮件将不再进行指纹的统计',
        spams8001: '设置相同主题的审计周期，周期不能低于10分钟，单位为分钟',
        spams9001: '设置相同主题的审计次数，在审计周期内达到次数则拒绝，次数不能低于10次',
        spams10001: '不同的url解析到同一个IP地址时，当url数量达到设置数量时，即判定为垃圾邮件，最小设置值4',
        spams11001: '当一封邮件中的链接数量小于等于设置数量时，才检查url是否在黑名单中，最小设置值2',
        spams12001: '设置通知邮件的自定义标题，不设置则保持原邮件标题',
        // 反病毒基本参数
        virus1: '病毒扫描动作',
        virus2: '病毒扫描超时时间',
        virus3: '病毒扫描最大邮件大小',
        virus4: '瑞星反病毒引擎端口',
        virus5: '瑞星反病毒引擎主机',
        virus6: '是否启动病毒扫描',
        virus7: '启用瑞星反病毒引擎',
        virus8: '拦截病毒是否隔离',
        virus9: '启用内置杀毒引擎',
        virus10: '若关闭病毒扫描，则不会对邮件进行病毒扫描',
        virus11: '瑞星网络杀毒引擎',
        virus12: '启用后，病毒扫描被拒绝的垃圾邮件，均会在隔离区保留一份单副本',
        virus13: '启用360天擎反病毒引擎',
        virus14: '360天擎网络杀毒引擎',
        virus15: '360天擎杀毒二进制程序',
        virus16: '360天擎杀毒中间件',
        virus17: '清理病毒',
        virus18: '保存spam时清理病毒',
        virus19: '重定向病毒文件',
        // 日志清理设置
        logc1: '邮件日志文件保留天数',
        logc2: '过滤日志文件保留天数',
        logc3: '认证日志文件保留天数',
        logc4: '队列日志保留天数',
        logc5: '实时过滤日志保留天数',
        logc6: '隔离邮件保留天数',
        logc7: '归档邮件保留天数',
        logc8: '每页日志默认显示条数',
        // 警报设置
        alert1: '警报通知发件人',
        alert2: '警报通知收件人',
        alert3: '异常程序',
        alert4: '异常账户',
        alert5: '版本升级',
        alert6: '授权到期',
        alert7: '硬盘容量',
        alert8: '异常IP认证',
        alert9: '异常IP拒绝',
        alert10: '队列报警',
        alert15: 'tls证书到期告警',
        // 实时黑名单
        alert11: '域名地址',
        alert12: '返回代码IP',
        alert13: '添加实时黑名单',
        alert16: '编辑实时黑名单',
        alert14: '借助其他反垃圾组织实时查询黑名单',
        // 远程syslog配置
        remote_a1: '启用实时过滤日志syslog',
        remote_a2: '启用则实时过滤日志会syslog至远程主机',
        remote_a3: '远程syslog主机',
        remote_a4: '默认为514端口，如需设置端口，则设置如：1.1.1.1:514,设置多个主机请使用逗号隔开',
        remote_a5: '添加syslog信头key',
        remote_a6: '一行一个信头key',
        remote_a7: 'Syslog默认包含有时间、反垃圾ID、IP地址、发件人、收件人、HELO主机名、主题、网关接收状态信息，可自定义添加需要的邮件信头中的内容，如Message-ID、Return-Path等',
        // 离线测试配置
        remote_b1: '启用离线测试',
        remote_b2: '离线测试前，基础配置邮件传送信任IP（离线测试发送连接IP）、中继域名（离线测试接收账号域名）、路由需配置完成',
        remote_b3: '测试发送账号',
        remote_b4: '进行离线测试时针对设置的发送账号部分策略不进行过滤',

    }

}